import { EventEmitter } from "events";
export var ConnectorEvents;
(function (ConnectorEvents) {
    ConnectorEvents["UPDATE"] = "CONNECTOR_UPDATE";
    ConnectorEvents["ERROR"] = "CONNECTOR_ERROR";
    ConnectorEvents["DEACTIVATE"] = "CONNECTOR_DEACTIVATE";
})(ConnectorEvents || (ConnectorEvents = {}));
export class ConnectorEmitter extends EventEmitter {
    constructor(debug) {
        super();
        this.debug = debug;
    }
    emitUpdate(update) {
        if (this.debug) {
            console.debug(`'${ConnectorEvents.UPDATE}'`, update);
        }
        this.emit(ConnectorEvents.UPDATE, update);
    }
    emitError(error) {
        if (this.debug) {
            console.debug(`'${ConnectorEvents.ERROR}'`, error);
        }
        this.emit(ConnectorEvents.ERROR, error);
    }
    emitDeactivate(reason) {
        if (this.debug) {
            console.debug(`'${ConnectorEvents.DEACTIVATE}'`);
        }
        this.emit(ConnectorEvents.DEACTIVATE, reason);
    }
}
